(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["carrusel-collection"] && !window.DesignMode) return;
  try {
    
    const slider = document.querySelector('.carousel-collection');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      console.log(walk);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailers"] && !window.DesignMode) return;
  try {
    
  document.getElementById('shopify-section-template--14502242025518__distributor').style.display = 'none';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !window.DesignMode) return;
  try {
        
  var repeatText = document.getElementById("ticker_text").textContent;
  document.getElementById("ticker_text").innerHTML = document.getElementById("ticker_text").textContent.repeat(400);
  document.getElementById("ticker_text_2").innerHTML = document.getElementById("ticker_text_2").textContent.repeat(400);
  document.getElementById("ticker_text_3").innerHTML = document.getElementById("ticker_text_3").textContent.repeat(400);
  document.getElementById("ticker_text_4").innerHTML = document.getElementById("ticker_text_4").textContent.repeat(400);
  document.getElementById("ticker_text_5").innerHTML = document.getElementById("ticker_text_5").textContent.repeat(400);

  } catch(e) { console.error(e); }
})();

})();
